// extracted by mini-css-extract-plugin
module.exports = {"info":"ExtraWorkingUnit_info_2sO1D"};